// App.tsx
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Auth from "./pages/Auth/Auth";
import { Home } from "./pages/Home/Home";
import { Image } from "./pages/Image/Image";

function App() {
  const location = useLocation();

  useEffect(() => {}, [location]);

  return (
    <div className="App">
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/image" element={<Image />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
